import { render } from "./Connect.vue?vue&type=template&id=2af1c8b2"
import script from "./Connect.vue?vue&type=script&lang=js"
export * from "./Connect.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__